// extracted by mini-css-extract-plugin
module.exports = {"overAll":"singlebutton_overAll__S2JLT","btnContainer":"singlebutton_btnContainer__JEybR","title":"singlebutton_title__2vmyU","titleText":"singlebutton_titleText__WR0-9"};